import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { AssetActions } from '../actions/asset.actions';
import { Asset } from '../models/asset.model';
import { AssetService } from 'src/app/services/asset.service';
import { StorageService } from 'src/app/services/storage.service';
import { stateContentChanged } from './state-content-changed'

export class AssetStateModel {
    is_refreshing: boolean
    asset: Asset[]
}

@State<AssetStateModel>({
    name: 'asset',
    defaults: {
        is_refreshing: true,
        asset: []
    }
})
@Injectable()
export class AssetState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private assetService: AssetService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<AssetStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                       
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }   

    async ngxsOnChanges(change: NgxsSimpleChange) {                     
        if (this.storageService.is_initialized && stateContentChanged(change)) {
            const state_model: AssetStateModel = change.currentValue
            this.storageService.set('assets', JSON.stringify(state_model))   
        }  
    }

    async reloadStateFromStorage() {        
        const json: string = await this.storageService.get('assets');        
        if (json) {
            const state_model: AssetStateModel = JSON.parse(json)            
            if (state_model) {                
                this.store.dispatch(new AssetActions.Init(state_model));
                return
            } 
        }
        this.store.dispatch(new AssetActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.assetService.getAll()    
        if (objs != null) {
          // The service has already run buildMany over the response, so the
          // rows arriving here are built models. Building them a second time
          // allocated a duplicate object for every row and, where buildOne
          // rebuilds children, re-walked those too.
          this.store.dispatch(new AssetActions.Set(objs))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: AssetStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: AssetStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: AssetStateModel) {
        return state.asset
    }

    @Action(AssetActions.Refresh)
    async refresh({patchState}: StateContext<AssetStateModel>, {  }:AssetActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(AssetActions.Init)
    init({setState, getState}: StateContext<AssetStateModel>, { payload }:AssetActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new AssetActions.Refresh())
    }
    
    @Action(AssetActions.Set)
    set({setState}: StateContext<AssetStateModel>, { payload }:AssetActions.Set) {             
        setState({   
            is_refreshing: false,         
            asset: payload
        })
    }
}
